/* BLCKLINE review wall: tabs, platform/category filters, "Show more", read more, photo/video lightbox. */
(function () {
  function initSection(root) {
    if (root.dataset.blrReady) return;
    root.dataset.blrReady = '1';
    var perPage = parseInt(root.dataset.perPage, 10) || 6;
    var lightbox = root.querySelector('[data-blr-lightbox]');
    var lightboxBody = root.querySelector('[data-blr-lightbox-body]');

    function cards(panel) {
      return Array.prototype.slice.call(panel.querySelectorAll('.blr-card'));
    }

    function matches(panel, card) {
      var ok = true;
      panel.querySelectorAll('[data-blr-filter]').forEach(function (group) {
        var on = group.querySelector('[aria-pressed="true"]');
        var value = on ? on.dataset.value : '';
        if (value && card.dataset[group.dataset.blrFilter] !== value) ok = false;
      });
      return ok;
    }

    // Phones show every matching card in a swipeable row; wider screens page with "Show more".
    var phone = window.matchMedia('(max-width: 749px)');

    // Show the first `limit` matching cards; hide the rest and toggle "Show more".
    function render(panel, limit) {
      if (phone.matches) limit = Infinity;
      var shown = 0;
      var matching = 0;
      cards(panel).forEach(function (card) {
        if (!matches(panel, card)) { card.hidden = true; return; }
        matching += 1;
        card.hidden = shown >= limit;
        if (!card.hidden) shown += 1;
      });
      panel.dataset.limit = limit;
      var more = panel.querySelector('[data-blr-more]');
      if (more) more.hidden = shown >= matching;
      checkClamps(panel);
    }

    function checkClamps(panel) {
      cards(panel).forEach(function (card) {
        var body = card.querySelector('[data-blr-clamp]');
        var btn = card.querySelector('[data-blr-readmore]');
        if (!body || !btn || card.hidden || body.classList.contains('is-open')) return;
        btn.hidden = body.scrollHeight <= body.clientHeight + 2;
      });
    }

    root.querySelectorAll('[data-blr-panel]').forEach(function (panel) {
      render(panel, perPage);
    });
    phone.addEventListener('change', function () {
      root.querySelectorAll('[data-blr-panel]').forEach(function (panel) { render(panel, perPage); });
    });
    // "Read reviews" links elsewhere on the page (e.g. the review card under the title) open a tab.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-blr-open]');
      if (!link) return;
      var tab = root.querySelector('[data-blr-tab="' + link.dataset.blrOpen + '"]');
      if (tab) tab.click();
    });

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-blr-tab]');
      if (tab) {
        root.querySelectorAll('[data-blr-tab]').forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-blr-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.blrPanel !== tab.dataset.blrTab;
          if (!panel.hidden) checkClamps(panel);
        });
        return;
      }

      var chip = event.target.closest('.blr__chip');
      if (chip) {
        var group = chip.closest('[data-blr-filter]');
        group.querySelectorAll('.blr__chip').forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        render(chip.closest('[data-blr-panel]'), perPage);
        return;
      }

      var more = event.target.closest('[data-blr-more]');
      if (more) {
        var panel = more.closest('[data-blr-panel]');
        render(panel, (parseInt(panel.dataset.limit, 10) || perPage) + perPage);
        return;
      }

      var readMore = event.target.closest('[data-blr-readmore]');
      if (readMore) {
        var body = readMore.closest('.blr-card').querySelector('[data-blr-clamp]');
        var open = body.classList.toggle('is-open');
        readMore.textContent = open ? 'Show less' : 'Read more';
        return;
      }

      var photo = event.target.closest('[data-blr-photo], [data-blr-video]');
      if (photo && lightbox && typeof lightbox.showModal === 'function') {
        lightboxBody.innerHTML = '';
        if (photo.hasAttribute('data-blr-video')) {
          lightboxBody.appendChild(photo.querySelector('template').content.cloneNode(true));
        } else {
          var img = document.createElement('img');
          img.src = photo.dataset.full;
          img.alt = (photo.querySelector('img') || {}).alt || 'Customer photo';
          lightboxBody.appendChild(img);
        }
        lightbox.showModal();
        return;
      }

      if (event.target.closest('[data-blr-close]') || event.target === lightbox) {
        lightbox.close();
      }
    });

    if (lightbox) {
      lightbox.addEventListener('close', function () { lightboxBody.innerHTML = ''; });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-blr]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
